// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as HealthRouteImport } from './routes/health'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicVerifyEmailRouteImport } from './routes/(public)/verify-email'
import { Route as publicTermsRouteImport } from './routes/(public)/terms'
import { Route as publicSupportRouteImport } from './routes/(public)/support'
import { Route as publicScannerRouteImport } from './routes/(public)/scanner'
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password'
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy'
import { Route as publicMagicLinkVerifyEmailRouteImport } from './routes/(public)/magic-link-verify-email'
import { Route as publicMagicLinkRouteImport } from './routes/(public)/magic-link'
import { Route as publicInviteRouteImport } from './routes/(public)/invite'
import { Route as publicDeckBuilderRouteImport } from './routes/(public)/deck-builder'
import { Route as publicCollectionTrackerRouteImport } from './routes/(public)/collection-tracker'
import { Route as publicChangelogRouteImport } from './routes/(public)/changelog'
import { Route as publicChangeEmailConfirmOldRouteImport } from './routes/(public)/change-email/confirm-old'
import { Route as publicChangeEmailConfirmNewRouteImport } from './routes/(public)/change-email/confirm-new'

const HealthRoute = HealthRouteImport.update({
            id: '/health',path: '/health',getParentRoute: () => rootRouteImport
          })
const publicRouteRoute = publicRouteRouteImport.update({
            id: '/(public)',getParentRoute: () => rootRouteImport
          })
const publicIndexRoute = publicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => publicRouteRoute
          })
const publicVerifyEmailRoute = publicVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => publicRouteRoute
          })
const publicTermsRoute = publicTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => publicRouteRoute
          })
const publicSupportRoute = publicSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => publicRouteRoute
          })
const publicScannerRoute = publicScannerRouteImport.update({
            id: '/scanner',path: '/scanner',getParentRoute: () => publicRouteRoute
          })
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => publicRouteRoute
          })
const publicPrivacyRoute = publicPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => publicRouteRoute
          })
const publicMagicLinkVerifyEmailRoute = publicMagicLinkVerifyEmailRouteImport.update({
            id: '/magic-link-verify-email',path: '/magic-link-verify-email',getParentRoute: () => publicRouteRoute
          })
const publicMagicLinkRoute = publicMagicLinkRouteImport.update({
            id: '/magic-link',path: '/magic-link',getParentRoute: () => publicRouteRoute
          })
const publicInviteRoute = publicInviteRouteImport.update({
            id: '/invite',path: '/invite',getParentRoute: () => publicRouteRoute
          })
const publicDeckBuilderRoute = publicDeckBuilderRouteImport.update({
            id: '/deck-builder',path: '/deck-builder',getParentRoute: () => publicRouteRoute
          })
const publicCollectionTrackerRoute = publicCollectionTrackerRouteImport.update({
            id: '/collection-tracker',path: '/collection-tracker',getParentRoute: () => publicRouteRoute
          })
const publicChangelogRoute = publicChangelogRouteImport.update({
            id: '/changelog',path: '/changelog',getParentRoute: () => publicRouteRoute
          })
const publicChangeEmailConfirmOldRoute = publicChangeEmailConfirmOldRouteImport.update({
            id: '/change-email/confirm-old',path: '/change-email/confirm-old',getParentRoute: () => publicRouteRoute
          })
const publicChangeEmailConfirmNewRoute = publicChangeEmailConfirmNewRouteImport.update({
            id: '/change-email/confirm-new',path: '/change-email/confirm-new',getParentRoute: () => publicRouteRoute
          })





const publicRouteRouteChildren = {
  publicChangelogRoute: publicChangelogRoute,publicCollectionTrackerRoute: publicCollectionTrackerRoute,publicDeckBuilderRoute: publicDeckBuilderRoute,publicInviteRoute: publicInviteRoute,publicMagicLinkRoute: publicMagicLinkRoute,publicMagicLinkVerifyEmailRoute: publicMagicLinkVerifyEmailRoute,publicPrivacyRoute: publicPrivacyRoute,publicResetPasswordRoute: publicResetPasswordRoute,publicScannerRoute: publicScannerRoute,publicSupportRoute: publicSupportRoute,publicTermsRoute: publicTermsRoute,publicVerifyEmailRoute: publicVerifyEmailRoute,publicIndexRoute: publicIndexRoute,publicChangeEmailConfirmNewRoute: publicChangeEmailConfirmNewRoute,publicChangeEmailConfirmOldRoute: publicChangeEmailConfirmOldRoute
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(publicRouteRouteChildren)

const rootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,HealthRoute: HealthRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)